// Thin wrapper over .cn-btn — variant/size map 1:1 to CSS modifiers.
export default function Button({ variant = 'gold', size = 'md', as: Tag = 'button', className = '', ...rest }) {
  return <Tag className={`cn-btn cn-btn--${variant} cn-btn--${size} ${className}`.trim()} {...rest} />
}
